const messages = {
  payoutsDescription: "Bekijk hier het overzicht van uw bonusuitbetaling(en).",
  paidOut: "(Uitbetaald)",
  makeChoice: "Maak hier uw keuze",
  seeAll: "Weergeven alles",
  clear: "Verwijderen",
  back: "Terug",
  save: "Speichern",
  close: "Sluiten",
  of: "Van",
  to: "Naar",
  copyrights: "© {date} Bridgestone",
  pageNotFound: "Pagina niet gevonden",
  accessDenied: "Toegang geweigerd",
  search: "Zoek",
  year: "Jaar",
  buttons: {
    loading: "Laden...",
    export: "Exporteren",
    delete: "Verwijderen",
    save: "Opslaan",
    cancel: "Annuleren",
    next: "Volgende",
    back: "Terug",
    skip: "Skip",
    send: "Opslaan",
    clear: "Verwijderen",
    readNow: "Lees nu",
    openBonusPayout: "OPEN BONUSUITBETALING",
    pointsList: "Naar het puntenoverzicht",
    more: "Meer",
    close: "Sluiten",
    reportError: "Fout melden",
    accept: "Accepteren",
    download: "Downloaden",
    dealerInfoDownload: "DOWNLOAD DEALERINFORMATIE",
    toTheBasket: "In het winkelmandje",
    toOrderDelivery: "Ga door naar het leveringsadres",
    discover: "Ontdekken",
    newAddress: "MAAK EEN NIEUW AFLEVERADRES AAN",
    selectAddressBtn: "Selecteer uw leveradres",
    toOrderSummary: "Naar uw bestellingsoverzicht",
    placeOrder: "Bestelling bevestigen",
    toDashboard: "Naar de startpagina",
    newOrder: "Nieuwe bestelling",
    userOrders: "Naar uw bestellingen",
    toSearch: "Zoek",
    select: "Kiezen",
    moreCustomerNumbers: "+ EXTRA KLANTNR. OPGEVEN",
    loadMore: "Meer laden",
    toStaffDashboard: "Naar dashboard",
    toQuiz: "Naar de quiz",
    vouchers: "Naar het puntenoverzicht",
    exchangeVoucher: "Vouchercode inwisselen",
    confirm: "BEVESTIGEN",
    sharePoints: "Deel punten",
    downloadSelection: "Download selectie",
    selectAll: "Selecteer alles",
    deselectAll: "Verwijder selectie",
    setFilters: "Filter",
    clearFilters: "Filter resetten",
    create: "Aanmaken",
    update: "Update",
    toBDrive: "NAAR B-DRIVE",
    preview: "Voorbeeld",
    clickHere: "klik hier",
    sendRequest: "Verzend verzoek",
    formButton: "naar het formulier",
    discoverButton: "Ontdekken",
    sendButton: "Opslaan",
    makeContact: "Stuur een e-mail",
    userProfile: "Naar uw gegevens",
    mailbox: "Naar uw inbox",
    edit: "Bewerking",
    downloadAll: "Download alles",
    toProductInfo: "ONTDEK PRODUCTINFORMATIE",
    toAccount: "NAAR DE PUNTENACCOUNT",
    toSalesPromotions: "REGISTREER NU UW BEDRIJF",
    show: "ONTDEK NU",
    toOnlineTrainings: "NAAR DE ONLINE TRAININGEN",
    toDownload: "Naar Downloads",
    calculate: "Berekenen",
    reset: "Opnieuw instellen",
    register: "Aanmelden",
    refuseBtn: "WEIGEREN",
    acceptBtn: "ACCEPTEER",
    toCommitmentLetter: "NAAR Voorwaarden voor deelname",
    toKickbackFeeInfo: "NAAR UITLEG BONUS EN PUNTEN",
    directBuy: "Bestel direct",
    toDiscover: "Ontdekken",
    all: "Alles tonen",
    exchangeKickback: "BONUS INWISSELEN VOOR MARKETINGPUNTEN",
    convert: "Omzetten",
    toFavorites: "Naar uw favoriete producten",
  },
  tooltips: {
    info: "Hulp nodig? Contacteer plus-nl&commat;bridgestone.eu ",
  },
  confirmation: {
    header: "Bevestiging vereist",
    message: "Wilt u dit record verwijderen?",
  },
  nav: {
    dashboard: "Home",
    accountDashboard: "Startpagina",
    account: "Mijn BRIDGESTONE <span class='text-danger'>PLUS</span>",
    mailbox: "Inbox",
    singleMailbox: "Inbox",
    stammdaten: "Mijn Profiel",
    news_feeds: "Nieuws",
    pointsOverview: "Mijn bandenbestellingen",
    rewardsOverview: "Uitleg bonus & punten",
    about: "Over BRIDGESTONE <span class='text-danger'>PLUS</span>",
    service_number: "Servicenummers",
    shop: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
    salesPromotions: "Verkoopbevordering",
    shopCategory: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
    productDetails: "Productgegevens",
    userOrders: "Mijn bestellingen",
    shoppingCart: "Winkelmand",
    orderDelivery: "Verzendadres",
    orderSummary: "Bestellingsoverzicht",
    orderComplete: "Bestelling voltooid",
    text_page: "Statische pagina",
    staff: "Service Dashboard",
    onlineTrainings: "Online trainingen",
    trainings: "Trainingen",
    training: "Training",
    trainingForm: "Trainingsformulier",
    staffVouchers: "Vouchers",
    wholesalerVouchers: "Vouchercodes",
    promotions: "Dashboard",
    brochure_prices: "Productbrochures",
    investment: "Investeringssteun",
    media: "Mediapakketten",
    medias: "Producten & Media",
    preislisten: "Prijslijsten",
    wholesaler: "Dashboard",
    contact_service: "Contact & Service",
    dekouple_contact: "ASSISTANCE BOUTIQUE",
    bridgestone_contact: "ASSISTANCE BRIDGESTONE PLUS",
    productInfo: "Productinformatie",
    produktbroschuren: "Productbrochures",
    technologien: "Technologieën, markeringen en meer",
    firestoneProduktbroschuren: "Firestone-producten",
    bDrive: "Productafbeeldingen",
    consents: "Toestemmingen",
    touch_incentive: "Contact Touch Incentive",
    strategic_partners: "Distributeurs contact",
    preislistenList: "Prijslijsten",
    pkw: "Personenwagens, 4x4/SUV en bestelwagens",
    commitment_letter: "Voorwaarden voor deelname",
    first_stop: "Bridgestone bandengarantie",
    payouts: "Bonusuitbetaling",
  },
  breadcrumbs: {
    dashboard: "Startpagina",
    accountDashboard: "Startpagina",
    account: "Mijn BRIDGESTONE <span class='text-danger'>PLUS</span>",
    mailbox: "Inbox",
    singleMailbox: "Inbox",
    stammdaten: "Mijn Profiel",
    news_feeds: "Nieuws",
    pointsOverview: "Mijn bandenbestellingen",
    rewardsOverview: "Uitleg bonus & punten",
    about: "Over BRIDGESTONE PLUS",
    service_number: "Servicenummers",
    shop: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
    salesPromotions: "Verkoopbevordering",
    shopCategory: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
    productDetails: "Productgegevens",
    userOrders: "Mijn bestellingen",
    shoppingCart: "Winkelmand",
    orderDelivery: "Verzendadres",
    orderSummary: "Bestellingsoverzicht",
    orderComplete: "Bestelling voltooid",
    staff: "Service Dashboard",
    onlineTrainings: "Online trainingen",
    trainings: "Trainingen",
    training: "Training",
    trainingForm: "Trainingsformulier",
    staffVouchers: "Vouchers",
    wholesalerVouchers: "Vouchercodes",
    promotions: "Dashboard",
    brochure_prices: "Productbrochures",
    investment: "Investeringssteun",
    media: "Mediapakketten",
    medias: "Producten & Media",
    preislisten: "Prijslijsten",
    wholesaler: "Dashboard",
    contact_service: "Contact & Service",
    dekouple_contact: "ASSISTANCE BOUTIQUE",
    bridgestone_contact: "ASSISTANCE BRIDGESTONE PLUS",
    productInfo: "Productinformatie",
    technologien: "Technologieën, markeringen en meer",
    firestoneProduktbroschuren: "Firestone-producten",
    produktbroschuren: "Productbrochures",
    bridgestoneProduktbroschuren: "Productbrochures",
    bDrive: "Productafbeeldingen",
    touch_incentive: "Contact Touch Incentive",
    strategic_partners: "Distributeurs contact",
    preislistenList: "Prijslijsten",
    pkw: "Personenwagens, 4x4/SUV en bestelwagens",
    commitment_letter: "Voorwaarden voor deelname",
    first_stop: "Bridgestone bandengarantie",
    payouts: "Bonusuitbetaling",
  },
  menu: {
    account: "Mijn BRIDGESTONE <span class='text-danger'>PLUS</span>",
    plus: 'Over Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Verkoopondersteuning",
    mailbox: "Inbox",
    about: 'Over BRIDGESTONE <span class="text-danger">Plus</span>',
    trainingAndCourses: "Training & onderwijs",
    externalTraining: "Externe training",
    productInfo: "Productinformatie",
    productBrochures: "Productbrochures",
    priceLists: "Prijslijst",
    price: "Prikaat",
    complaintForm: "Klachten formulier",
    sales_support: "Verkoopondersteuning",
    contact_service: "Contact & Service",
    logOut: "Afmelden",
    news: "Huidig",
    news_feeds: "Nieuws",
    service_number: "Servicenummers",
    salesPromotions: "Verkoopbevorderende acties",
    shop: "BRIDGESTONE <span class='text-danger'>Plus</span> Shop",
    onlineTrainings: "Online trainingen",
    trainings: "Trainingen",
    brochure_prices: "Productbrochures",
    media: "Producten & Media",
    medias: "Producten & Media",
    stammdaten: "Mijn Profiel",
    preislisten: "Prijslijsten",
  },
  validation: {
    requiredField: "Verplichte velden",
  },
  sortBy: {
    default: "Sorteer op",
    desc: "Sorteer op: Nieuwste",
    asc: "Sorteer op: Oudste",
    name: "Namen",
    date: "Datum",
    choiceBy: "Selectie sorteren op",
  },
  month: {
    1: "januari",
    2: "februari",
    3: "maart",
    4: "april",
    5: "mei",
    6: "juni",
    7: "juli",
    8: "augustus",
    9: "september",
    10: "oktober",
    11: "november",
    12: "december",
  },
};

export default {
  messages,
};
